import React, { useState, useRef } from 'react';
import { Copy, Check } from 'lucide-react';

/**
 * Componente para exibir um item de dado com label e valor
 * Opções para destacar, copiar e exibir ícone
 */
const DataItem = ({
  label,
  value,
  icon = null,
  highlight = false,
  isCopyable = false,
  valueColor = '',
  compact = false,
}) => {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(null);
  // Se o valor for undefined, null, ou string vazia, exibir traço
  const displayValue = value === undefined || value === null || value === '' ? '--' : value;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(displayValue);
      setCopied(true);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setCopied(false), 1500);
    } catch (_) {
      /* no-op */
    }
  };

  return (
    <div className={`flex flex-col ${compact ? 'mb-1.5' : 'mb-2'}`}>
      <div
        className={`flex items-center ${compact ? 'gap-0.5 text-[11px]' : 'gap-1 text-xs'} text-gray-600`}
      >
        {icon && <span className="flex items-center">{icon}</span>}
        <span>{label}</span>
      </div>

      <div className="flex items-center gap-1.5">
        <span
          className={`font-medium ${highlight ? 'text-blue-700' : valueColor || 'text-gray-900'} ${compact ? 'text-xs' : 'text-sm'}`}
        >
          {displayValue}
        </span>

        {isCopyable && displayValue !== '--' && (
          <button
            onClick={handleCopy}
            className={`p-0.5 transition-colors duration-150 cursor-pointer ${copied ? 'text-green-600 hover:text-green-700' : 'text-gray-400 hover:text-blue-600'}`}
            title={copied ? 'Copiado' : 'Copiar para área de transferência'}
          >
            {copied ? <Check size={12} /> : <Copy size={12} />}
          </button>
        )}
      </div>
    </div>
  );
};

export default DataItem;
